import { useState } from 'react';
import './Blog.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import MainScreen from '../../components/MainScreen';
import PreFooter from '../../components/PreFooter';
import Back from './bg.jpg';
import Popup from '../../components/Popup';
import Image1 from './1.jpg';
import Image2 from './2.jpg';
import Image3 from './3.jpg';
import Image4 from './4.jpg';
import Image5 from './5.jpg';
import Image6 from './6.jpg';
import Image7 from './7.jpg';
import Image8 from './8.jpg';

const Blog = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <MainScreen
        background={Back}
        title='Healthcare Insights & Industry Trends'
        text='Expert perspectives on staffing, leadership, and the future of healthcare delivery'
      />

      <div className='blogCards'>
        <div className='blogCardsRow'>
          <div className='blogCard' onClick={() => navigate('/blog/the-benefits-of-a-positive-attitude')}>
            <div className='blogCardImage'>
              <img src={Image3} />
            </div>
            <span className='blogCardTitle'>No Bad Days: The Benefits of a Positive Attitude in Healthcare</span>
            <span className='blogCardText'>
              Let’s face it. No matter what industry a person works in, it’s nearly impossible to maintain a positive attitude
              100% of the time. The early mornings, long hours, or unpleasant coworkers can be enough to drive someone mad. But
              the harsh reality is, most of us don’t have a choice about whether we have to work or not, so might as well make the
              most of it! If you struggle some days, you’re not alone.
            </span>
            <span className='blogCardDate'>December 17, 2025</span>
          </div>
          <div className='blogCard' onClick={() => navigate('/blog/the-50-mile-myth-for-travelers')}>
            <div className='blogCardImage'>
              <img src={Image1} />
            </div>
            <span className='blogCardTitle'>The 50 Mile Myth for Travelers</span>
            <span className='blogCardText'>
              Probably one of the most common misconceptions we hear, specifically for travelers, is the ‘50 Mile Rule’ regarding
              tax free stipends. This topic is often discussed and easily accepted as truth among travelers, no matter how many
              times it’s refuted. This ‘rule’ claims that employees can accept tax-free stipends as part of their travel pay if
              their assignment is 50 miles or more from their tax home. The IRS doesn’t make this determination, and the reality
              is the ‘50 Mile Rule’ for travelers doesn’t exist.
            </span>
            <span className='blogCardDate'>November 15, 2025</span>
          </div>
          <div className='blogCard' onClick={() => navigate('/blog/the-unexpected-loss-of-a-leader')}>
            <div className='blogCardImage'>
              <img src={Image8} />
            </div>
            <span className='blogCardTitle'>The Unexpected Loss of a Leader</span>
            <span className='blogCardText'>
              Each of a hospital’s departments is critical and must function uninterrupted, yet an unplanned vacancy in management
              can negatively impact processes, productivity, and profitability.
            </span>
            <span className='blogCardDate'>December 11, 2025</span>
          </div>
        </div>
        <div className='blogCardsRow'>
          <div className='blogCard' onClick={() => navigate('/blog/burnout-disengagement-and-low-morale')}>
            <div className='blogCardImage'>
              <img src={Image7} />
            </div>
            <span className='blogCardTitle'>Burnout, Disengagement, and Low Morale</span>
            <span className='blogCardText'>
              Burnout rates among health care leaders and physicians are nearly double that of workers in other professions.
              Reduced empathy and productivity can spiral into serious quality and financial issues for healthcare facilities if
              ignored.
            </span>
            <span className='blogCardDate'>December 4, 2025</span>
          </div>
          <div className='blogCard' onClick={() => navigate('/blog/a-powerful-leadership-tool')}>
            <div className='blogCardImage'>
              <img src={Image2} />
            </div>
            <span className='blogCardTitle'>Storytelling: A Powerful Leadership Tool</span>
            <span className='blogCardText'>
              Storytelling is a way for leaders to inspire the organization, share a vision, teach valuable lessons, define
              culture and values, and explaining who you are and what you believe through an engagement medium that audiences
              prefer. However, what if you don’t think you’re a captivating storyteller? We have five tips that will help you
              build your storytelling skills.
            </span>
            <span className='blogCardDate'>December 1, 2025</span>
          </div>
          <div className='blogCard' onClick={() => navigate('/blog/how-to-be-successful-working-with-millennials')}>
            <div className='blogCardImage'>
              <img src={Image5} />
            </div>
            <span className='blogCardTitle'>How to be Successful Working with Millennials</span>
            <span className='blogCardText'>
              A recent Gallup report revealed some interesting findings on millennials and their habits. For example, millennials
              were found to be the least engaged generation, with only 29% saying they are “emotionally and behaviorally connected
              to their job and company.” So how can you be successful working with millennials?
            </span>
            <span className='blogCardDate'>November 26, 2025</span>
          </div>
        </div>
        <div className='blogCardsRow'>
          <div className='blogCard' onClick={() => navigate('/blog/navigating-major-staffing-shortages-in-healthcare')}>
            <div className='blogCardImage'>
              <img src={Image4} />
            </div>
            <span className='blogCardTitle'>Navigating Major Staffing Shortages in Healthcare</span>
            <span className='blogCardText'>
              Unprecedented shortages of qualified healthcare staff pose immediate and long-term concerns for health care
              organizations. Learn how proactive leaders are staying ahead of the crisis.
            </span>
            <span className='blogCardDate'>November 20, 2025</span>
          </div>
        </div>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <Footer />
    </div>
  );
};

export default Blog;
